<template>
  <div>
    <yandex-map
      :coords="currentCenter"
      :zoom="zoom"
      :controls="controls"
      style="width: 100%; height: 100%"
    >
      <div v-if="!!this.token">
        <ymap-marker
          v-for="(marker, index) in markers"
          :key="index"
          :markerId="index"
          :name="marker.street"
          ref="myMarker"
          :coords="marker.coords"
          :street="marker.street"
          :balloon-template="balloonTemplate(selectedMarker)"
          @click="onClick"
          
        @balloonopen="bindListener"
        @balloonclose="unbindListener"
        />
      </div>
      <div v-else>
        <ymap-marker
          v-for="(marker, index) in markers"
          :key="index"
          :markerId="index"
          :name="marker.street"
          ref="myMarker"
          :coords="marker.coords"
          :street="marker.street"
          :balloon-template="balloonTemplate1(selectedMarker,dellSelectedMarkerF)"
          @balloonopen="bindListener"
          @balloonclose="unbindListener"
          @click="onClick"
        />
      </div>
    </yandex-map>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "SimpleMap",
  data() {
    return {
      zoom: 12,
      currentCenter: [47.2243657, 38.9105216],
      markers: [],
      errors: [],
      markerIconSVG: require("@/assets/MarkerIcon2.svg"),
      controls: [
        "typeSelector",
        "zoomControl",
        "rulerControl",
        "geolocationControl",
      ],
      staticAnchor: [16, 37],
      staticIconSize: [26, 34],
      selectedMarker: {},
      dellSelectedMarkerF:()=>{},
      token: this.$store.state.isAuthenticated,
    };
  },
  created() {
    axios
      .get("api/v1/map/markers")
      .then((response) => {
        for (var marker_info of response.data) {
          // var delete_link = "http://tagproject-api.sfedu.ru/api/v1/map/markers/delete/"+marker_info.id
          this.markers.push({
            id: marker_info.id,
            street: marker_info.street,
            name: marker_info.name,
            description: marker_info.description,
            marker_type: marker_info.marker_type,
            coords: marker_info.gps.split(","),
            image: marker_info.get_image,
          });
        }
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
  methods: {
    ...mapMutations(["verifyRefreshToken"]),

    deleteMarker: function(marker_id) {
      this.verifyRefreshToken();
      axios
        .delete(
          `https://tagproject-api.sfedu.ru/api/v1/map/markers/delete/${marker_id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.accessToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.$router.go();
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    balloonTemplate1: function(selectedMarker) {
      return `
        <div class="balloon">
            <img class="balloon__img" center id="marker-image" src="${selectedMarker.image}" alt="..."/>
            <div class="container" style="width: 300px !important">
                <div class="balloon__info">
                    <div class="col-md-12">
                        <p class="text-center">${selectedMarker.street}</p>
                    </div>
                </div>
            </div>
        </div>`;
    },
     balloonTemplate: function(selectedMarker) {
      return `
<div class="balloon">
    <img class="balloon__img" center id="marker-image" src="${selectedMarker.image}" alt="..."/>
    <div class="container" style="width: 300px !important">
        <div class="balloon__info">
            <div class="col-md-12">
                <p class="text-center">${selectedMarker.street}</p>
                <div class="d-flex justify-content-center">
                    <br><br>
                    <button id="${selectedMarker.id}" class="delete-marker-button" variant="outline-danger">Удалить маркер</button>
                </div>
            </div>
        </div>
    </div>
</div>
`
    },

    onClick(e) {
      this.selectedMarker =this.markers[e.originalEvent.target.properties._data.markerId]
      },
    
    bindListener() {
      document.getElementById(`${this.selectedMarker.id}`).addEventListener('click', this.handler);
    },
    unbindListener() {
      document.getElementById(`${this.selectedMarker.id}`).removeEventListener('click', this.handler);
    },
    handler() {
      this.deleteMarker(this.selectedMarker.id)
    },
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),

  
  },
};
</script>

<style type="text/css">
.balloon__info {
  margin-top: 10px;
}
.balloon {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.balloon__img {
  max-height: 250px;
  max-width: 250px;
}

.ymaps-2-1-79-balloon,
.ymaps-2-1-79-balloon__layout {
  border-radius: 20px !important;
  border: 0;
}

.ymaps-2-1-79-balloon__layout {
  padding: 10px;
}
.delete-marker-button{
  background: local;
  border-radius: 20px;
  width:240px;
  font-size: 20px;
  font-weight: 700;
  
}
.delete-marker-button:hover{
    background: black;
    color: white;
  }
</style>